import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";

const days = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

export default function CuisinesAndTiming({
  cuisineName,
  setCuisineName,
  restaurantTimings,
  setRestaurantTimings,
}) {
  const [cuisines, setCuisines] = useState([]);

  useEffect(() => {
    axios.get("/restaurant/cuisines/get-all-cuisines").then((res) => {
      console.log(res.data.data);
      setCuisines(res.data.data);
    });
  }, []);

  function handleClick(e) {
    if (e.target.checked) {
      setCuisineName((prev) => [
        ...prev,
        e.target.parentNode.nextSibling.innerText,
      ]);
    } else {
      setCuisineName(
        cuisineName.filter(
          (cuisine) => cuisine !== e.target.parentNode.nextSibling.innerText
        )
      );
    }
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", marginBottom: "20px" }}
    >
      <div style={{ padding: "1px 0 20px 0" }}>
        <h3
          style={{
            marginBottom: "10px",
            fontWeight: "500",
            marginLeft: "10px",
            color: "gray",
          }}
        >
          Cuisines
        </h3>
        <div style={{ marginLeft: "10px" }}>
          {cuisines.map((cuisine) => (
            <FormControlLabel
              id={cuisine.id}
              value={cuisine.id}
              control={
                <Checkbox
                  value={cuisine.id}
                  id={cuisine.id}
                  sx={{
                    color: "#F4756B",
                    "&.Mui-checked": {
                      color: "#F4756B",
                    },
                  }}
                />
              }
              onClick={(e) => handleClick(e)}
              label={cuisine.cuisineName}
              labelPlacement="end"
            />
          ))}
        </div>
      </div>
      <div style={{ padding: "5px 0 20px 0" }}>
        <h3
          style={{
            marginBottom: "10px",
            fontWeight: "500",
            marginLeft: "10px",
            color: "gray",
          }}
        >
          Timings
        </h3>
        <div>
          {days.map((day) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <p
                  style={{
                    margin: "32px 0 0 10px",
                    fontSize: "17px",
                    backgroundColor: "#F4756B",
                    color: "white",
                    padding: "8px 25px",
                    borderRadius: "5px",
                    width: "150px",
                    textAlign: "center",
                  }}
                >
                  {day}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "5px 0",
                }}
              >
                <div>
                  <label
                    class="ml-3 font-normal text-s text-gray-500"
                    for="usernameField"
                  >
                    Opening Time
                  </label>
                  <input
                    class="flex items-center h-10 px-4 w-52 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                    type="text"
                    placeholder="10:00"
                    onChange={(e) => {
                      console.log(
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText
                      );
                      let weekDay =
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText;
                      const restaurantTiming = restaurantTimings.filter(
                        (timing) => {
                          return timing.weekDay === weekDay;
                        }
                      );
                      console.log(restaurantTiming);
                      restaurantTiming[0].openingTiming = e.target.value;
                    }}
                  />
                </div>
                <div>
                  <label
                    class="ml-3 font-normal text-s text-gray-500"
                    for="usernameField"
                  >
                    Break Time
                  </label>
                  <input
                    class="flex items-center h-10 px-4 w-52 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                    type="text"
                    placeholder="14:00-16:00"
                    onChange={(e) => {
                      console.log(
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText
                      );
                      let weekDay =
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText;
                      const restaurantTiming = restaurantTimings.filter(
                        (timing) => {
                          return timing.weekDay === weekDay;
                        }
                      );
                      console.log(restaurantTiming);
                      restaurantTiming[0].breakTiming = e.target.value;
                    }}
                  />
                </div>
                <div>
                  <label
                    class="ml-3 font-normal text-s text-gray-500"
                    for="usernameField"
                  >
                    Closing Time
                  </label>
                  <input
                    class="flex items-center h-10 px-4 w-52 bg-gray-200 mt-2 rounded focus:outline-none focus:ring-2 shadow-md"
                    type="text"
                    placeholder="23:00"
                    onChange={(e) => {
                      console.log(
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText
                      );
                      let weekDay =
                        e.target.parentNode.parentNode.parentNode.firstChild
                          .firstChild.innerText;
                      const restaurantTiming = restaurantTimings.filter(
                        (timing) => {
                          return timing.weekDay === weekDay;
                        }
                      );
                      console.log(restaurantTiming);
                      restaurantTiming[0].closingTiming = e.target.value;
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
